import { render, staticRenderFns } from "./CommAccidents.vue?vue&type=template&id=79cb4ba8&scoped=true"
import script from "./CommAccidents.vue?vue&type=script&lang=js"
export * from "./CommAccidents.vue?vue&type=script&lang=js"
import style0 from "./CommAccidents.vue?vue&type=style&index=0&id=79cb4ba8&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79cb4ba8",
  null
  
)

export default component.exports